// Order status codes
export const ORDER_STATUS = {
  READY: 900,
  PENDING: 1000,
  CANCELLED: 1100,
  FAILED: 1200,
  COMPLETED: 1300,
  IGNORED: 1400
} as const;

export type OrderStatusCode = typeof ORDER_STATUS[keyof typeof ORDER_STATUS];

// Order management routes
export const ORDER_ROUTES = {
  FULFILL: '/order-management/fulfill-cancel',
  INVOICE: '/order-management/invoice',
  ACCEPT: '/order-management/accept',
  ORDER_DETAILS: '/order-management/order-details',
  ACK_DETAILS: '/order-management/ack-details',
  SHIPMENT_DETAILS: '/order-management/shipment-details',
  INVOICE_DETAILS: '/order-management/invoice-details',
  RETURN_DETAILS: '/order-management/return-details'
} as const;

// API endpoints
export const API_ENDPOINTS = {
  ORDERS_EXPORT: '/api/v1/orders/export',
  TRACKING_UPLOAD: '/api/v1/shipments/trackingfile',
  PACKING_LIST: '/api/v1/Orders/PickList',
  FINANCING_CONNECT: '/api/v2/financing/connect',
  FINANCE_ORDERS: '/api/v2/financing/financeorders'
} as const;

// File types
export const FILE_TYPES = {
  CSV: 'csv',
  XLSX: 'xlsx',
  PDF: 'pdf',
  XML: 'xml',
  LEGACY: 'legacy'
} as const;

export type FileType = typeof FILE_TYPES[keyof typeof FILE_TYPES];

// Error level mapping
export const ERROR_LEVELS: Record<number, string> = {
  0: 'Success',
  1: 'Information',
  2: 'Warning',
  3: 'Error',
  4: 'Unknown'
};

// Export profile names
export const EXPORT_PROFILES = {
  WITH_DETAIL: 'Orders With Item Detail',
  WITHOUT_DETAIL: 'Orders Without Item Detail'
} as const;